module.exports = __webpack_public_path__ + "img/tool1.97b6166a.png";